<template>
    <div class="h-full text-center">
        <form
            v-if="! waitingForAuth"
            v-loading="loading"
            class="h-full flex flex-col md:py-2xl"
            @submit.prevent="submit"
        >
            <div class="form-group form-group-floating-label flex-1 flex items-center justify-center mb-md">
                <img
                    src="/img/bank-id.svg"
                    alt="BankID"
                    class="mb-md h-6xl"
                >
            </div>

            <div class="mt-auto flex flex-row-reverse flex-wrap md:flex-no-wrap">
                <button
                    type="submit"
                    class="btn is-primary btn-lg w-full"
                    @click="hideStandardLoginFormButtons"
                >
                    {{ lang('Logga in med BankID','Log in') }}
                </button>
            </div>

            <div v-if="error" class="bg-danger text-white p-md mt-lg">
                {{ error }}
            </div>
        </form>

        <div v-if="waitingForAuth">
            <div v-if="isMobileDevice">
                <p v-if="bankIdAppUrl && ! showQrCode">
                    <a :href="bankIdAppUrl" class="btn btn-lg is-primary py-xl px-xl">
                        {{ lang('Öppna BankID på denna enhet','Open BankID on this device') }}
                    </a>
                </p>

                <button
                    v-if="isMobileDevice && ! showQrCode"
                    class="btn btn-lg is-ghost py-xl px-xl"
                    @click="toggleQRCode"
                >
                    {{ lang('Mobilt BankID på annan enhet','Mobile BankID on another device') }}
                </button>
            </div>

            <div v-if="isMobileDevice ? qrCode && showQrCode : qrCode">
                <div class="flex justify-center mb-md">
                    <img
                        src="/img/bank-id.svg"
                        alt="BankID"
                        class="h-3xl"
                    >
                </div>
                <!-- eslint-disable vue/no-v-html -->
                <span v-html="qrCode" />

                <ol class="text-left my-xl text-xs md:text-sm max-w-sm mx-auto leading-normal">
                    <li>{{ lang('Starta BankID-appen på din mobil eller surfplatta', 'Start the BankID app on your mobile or tablet.') }}</li>
                    <li>{{ lang('Klicka på QR-ikonen i BankID-appen', 'Click on the QR icon in the BankID app') }}</li>
                    <li>{{ lang('Rikta kameran mot QR-koden som visas här på skärmen', 'Point the camera at the QR code shown here on the screen') }}</li>
                </ol>
            </div>

            <div class="flex justify-center my-lg">
                <button
                    type="button"
                    class="block btn btn-lg"
                    @click="cancel()"
                >
                    {{ lang('Avbryt','Cancel') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                error: null,
                waitingForAuth: false,
                bankIdAppUrl: null,
                loading: false,
                qrCode: null,
                showQrCode: false,
            };
        },
        computed: {
            isMobileDevice() {
                return utils.isMobileDevice();
            },
        },
        methods: {
            submit() {
                this.error = null;
                this.loading = true;

                axios.post(route('front.api.bank-id.init-auth'))
                    .then((response) => {
                        if (this.isMobileDevice) {
                            this.bankIdAppUrl = response.data.bankIdAppUrl;
                        }

                        this.qrCode = response.data.qrCode;

                        this.waitForAuth();
                    })
                    .catch(error => {
                        this.error = error.response.data.message;
                    })
                    .then(() => {
                        this.loading = false;
                    });
            },

            hide() {
                this.$emit('hide');
            },

            waitForAuth() {
                this.waitingForAuth = true;
                this.pollCount = 0;

                setTimeout(() => {
                    this.pollForAuth();
                }, 1000);
            },

            pollForAuth() {
                if (! this.waitingForAuth) {
                    return;
                }

                this.pollCount++;

                axios.get(route('front.api.bank-id.poll-for-auth'))
                    .then((response) => {
                        if (response.data.success) {
                            window.location.href = response.data.redirectUrl;
                        } else {
                            if (this.pollCount >= 40) {
                                this.waitingForAuth = false;
                                this.error = lang('Inloggningen tog för lång tid. Försök igen.','It took too long to log in');
                            } else {
                                this.qrCode = response.data.qrCode;

                                setTimeout(() => {
                                    this.pollForAuth();
                                }, 2000);
                            }
                        }
                    })
                    .catch(error => {
                        this.waitingForAuth = false;
                        this.error = error.response.data.message;
                    });
            },

            toggleQRCode() {
                this.showQrCode = ! this.showQrCode;
            },

            toggleLoginFormButtons(displayState) {
                const buttons = document.querySelectorAll('.login-form-btn');
                buttons.forEach((btn) => {
                    btn.style.display = displayState;
                });
            },

            hideStandardLoginFormButtons() {
                this.toggleLoginFormButtons('none');
            },

            cancel() {
                this.waitingForAuth = false;
                this.showQrCode = false;
                this.error = lang('Inloggningen avbröts', 'Login cancelled');

                axios.post(route('front.api.bank-id.cancel-auth'))
                    .then((response) => {
                    })
                    .catch(error => {
                        this.error = error.response.data.message;
                    });

                this.toggleLoginFormButtons('block');
            },
        },
    };
</script>
